@if (label || headerControl.length) {
    <div class="header"
         [ngClass]="{'content-hidden': hideContent}">
        @if (headerControl.length) {
            <div class="header-control before"
                 #before [ngClass]="{'empty': before.children.length === 0}">
                <ng-content select="fui-content-layout-header-control[slot=before]"></ng-content>
            </div>
        }
        <div class="header-label">
            <div class="header-label-title">
                {{ label | translate: i18nParams }}
            </div>
        </div>
        @if (headerControl.length) {
            <div class="header-control after"
                 #after [ngClass]="{'empty': after.children.length === 0}">
                <ng-content select="fui-content-layout-header-control[slot=after]"></ng-content>
            </div>
        }
    </div>
}
<div class="main" [hidden]="hideContent">
    <ng-content></ng-content>
</div>

